import { FormFieldGroup, FormInput, FormLabel } from '$components'
import { Input } from './index'

export function EditClientProfileContent() {
  return (
    <div className="flex flex-col gap-6 flex-grow">
      <div className="flex sm:flex-row flex-col gap-6">
        <FormFieldGroup>
          <FormLabel htmlFor={Input.FirstName}>
            First Name
          </FormLabel>

          <FormInput
            name={Input.FirstName}
            placeholder="Enter client's first name..."
          />
        </FormFieldGroup>

        <FormFieldGroup>
          <FormLabel htmlFor={Input.LastName}>
            Last Name
          </FormLabel>

          <FormInput
            name={Input.LastName}
            placeholder="Enter client's last name..."
          />
        </FormFieldGroup>
      </div>
    </div>
  )
}
